import { useState } from 'react';

import { ConfirmModal } from 'components/design-system/Modal/ConfirmModal';
import { SlideoutCommonProps } from 'components/design-system/Slideout';
import { clientApiPost } from 'lib/api_helper';
import { extendUrlByQueries } from 'lib/url_helpers';
import { Listing, ListingStatus, ListingWithOffers } from 'types';

type ArchiveListingModalProps<T> = {
  listing: T;
  closeModal: () => void;
  onArchiveListing: (listing: T) => void;
} & SlideoutCommonProps;

export const ArchiveListingModal = <T extends Listing | ListingWithOffers>({
  isOpen,
  closeModal,
  listing,
  onArchiveListing
}: ArchiveListingModalProps<T>) => {
  const [isProcessing, setIsProcessing] = useState(false);

  const submit = {
    title: <span className='white-space-nowrap riforma-regular'>Yes, remove listing</span>,
    className: 'me-2',
    onClick: () => {
      setIsProcessing(true);
      clientApiPost(extendUrlByQueries('/api/listings/archive', { ids: listing.id }), {}).finally(() => {
        setIsProcessing(false);
        closeModal();
        onArchiveListing({ ...listing, status: ListingStatus.Archived });
      });
    },
    loading: isProcessing
  };

  const cancel = {
    title: 'Nevermind',
    onClick: closeModal
  };

  return (
    <ConfirmModal
      isOpen={isOpen}
      closeModal={closeModal}
      submit={submit}
      cancel={cancel}
      title={<span className='fs-18px line-height-24px'>Are you sure you want to archive this listing?</span>}
    >
      <div className='py-5 riforma-regular px-3'>
        <span>If you archive this listing, it will be removed from your active inventory</span>
      </div>
    </ConfirmModal>
  );
};
